(() => {
  if (window.__baesicsRestockAttribution) return;
  const storageKey = 'baesics_restock_session_v1';
  const params = new URL(location.href).searchParams;
  let saved;
  try { saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch {}
  const tags = ['source', 'medium', 'campaign', 'content', 'term'];
  const hasCampaign = tags.some(k => params.has('utm_' + k)) || params.has('fbclid');
  if (!saved || hasCampaign) {
    let source = 'direct';
    try { const ref = new URL(document.referrer); if (ref.origin !== location.origin) source = ref.hostname; } catch {}
    saved = { source, landing_page: location.origin + location.pathname,
      session_id: saved?.session_id || crypto.randomUUID(), fbclid: params.get('fbclid') || '' };
    for (const k of tags) if (params.get('utm_' + k)) saved[k] = params.get('utm_' + k).slice(0, 250);
    if (params.get('fbclid') && !params.get('utm_source')) saved.source = 'meta';
    try { sessionStorage.setItem(storageKey, JSON.stringify(saved)); } catch {}
  }
  window.__baesicsRestockAttribution = saved;
  const token = params.get('restock_ref');
  if (token && /^[a-f0-9]{48}$/.test(token)) {
    fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { baesics_restock: token } })
    }).catch(() => {});
  }
})();
